import { computed, Signal } from '@angular/core';
import { Chart } from '../types/chart';
import { ChartRef } from '../types/refs';
import { DataSource } from '@softapps/core';

export interface ChartOptions {
  title?: Signal<string>;
  legend?: boolean;
  zoom?: boolean;
}

export function chart<TRow extends object>(
  dataSource: DataSource<TRow>,
  factory: (ref: ChartRef<TRow>) => void,
  options?: ChartOptions,
): Chart<TRow> {
  const series = computed(() => {
    const ref = new ChartRef<TRow>();
    factory(ref);
    return { series: ref.series, axes: ref.axes, filter: ref.filter, sort: ref.sort };
  });
  return {
    dataSource,
    series: computed(() => series().series),
    axes: computed(() => series().axes),
    title: options?.title,
    legend: options?.legend,
    zoom: options?.zoom,
    filter: computed(() => series().filter),
    sort: computed(() => series().sort),
  };
}
